import { useClients } from 'core/app/AppContext';
import useClientFromUrl from 'core/ui/utils/useClientFromUrl';

export const useClient = (customId?: string, customLevel?: string) => {
  const { clientId: currentCliendId, clientLevel: currentClientLevel } = useClientFromUrl();

  const id = customId ?? currentCliendId;
  const level = customLevel ?? currentClientLevel;

  const { getBrand, getSite, getGroup } = useClients();

  if (level === 'sites') {
    const site = getSite(id);
    return {
      name: site?.name,
      active: site?.hubspotActive,
    };
  }

  if (level === 'brands') {
    const brand = getBrand(id);

    return {
      name: brand?.name,
    };
  }

  if (level === 'groups') {
    const group = getGroup(id);

    return {
      name: group?.name,
    };
  }

  return {
    name: '',
  };
};

export default useClient;
